import { render, staticRenderFns } from "./CRMDashboard.vue?vue&type=template&id=d427ffea&scoped=true&"
import script from "./CRMDashboard.vue?vue&type=script&lang=js&"
export * from "./CRMDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d427ffea",
  null
  
)

export default component.exports